import React from 'react';
import { StyledIcons } from '../BorderControlRequirement.styles';

const EESIcon = () => (
  <StyledIcons
    data-testid="eesIcon"
    data-cy="eesIcon"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_976_12559)">
      <path
        d="M31.9921 64.0306V59.3455C23.0238 59.2527 14.2101 55.0469 9.03016 47.3156C7.39112 44.9343 5.9531 41.6872 5.2109 38.9039C5.17997 38.7802 5.27275 38.672 5.39645 38.672H5.76755C5.84486 38.672 5.92218 38.7183 5.9531 38.7957C6.2005 39.476 6.61799 40.5429 6.89632 41.146C7.17465 41.7954 7.49936 42.4603 7.83954 43.0788C9.16932 45.5528 10.9321 47.8413 13.035 49.7741C18.184 54.6139 25.0958 57.057 31.9921 56.8869V36.4917L15.7409 36.2598L15.6791 35.2702L30.3995 33.09L31.6829 13.4988H31.9921V7.83954C27.1678 7.94778 22.3744 9.30849 18.184 12.0763C14.4111 14.5503 11.3495 18.0139 9.47857 21.9724C8.98377 22.9929 8.56628 24.0753 8.2261 25.1422C8.17971 25.2504 8.14879 25.3741 8.11786 25.4824C8.00963 25.838 7.66945 26.0854 7.28288 26.0699H6.04588C5.48922 26.0699 5.0872 25.5597 5.22636 25.0494C6.66438 19.7148 10.1435 14.4421 14.6431 11.0094C19.7767 7.09733 25.9153 5.30367 31.9921 5.36552V0C14.3184 0.0463878 0 14.3648 0 32.0385C0 49.7123 14.3184 64.0306 31.9921 64.0306Z"
        fill="#00286A"
      />
      <path
        d="M54.9543 17.4413C56.5933 19.8226 58.0314 23.0697 58.7736 25.853C58.8045 25.9767 58.7117 26.0849 58.588 26.0849H58.2169C58.1396 26.0849 58.0623 26.0385 58.0314 25.9612C57.784 25.2809 57.3665 24.2139 57.0882 23.6109C56.8098 22.9615 56.4851 22.2966 56.1449 21.6781C54.8151 19.2041 53.0524 16.9156 50.9495 14.9828C45.8005 10.1584 38.9041 7.71535 32.0233 7.86997V13.5293H32.7191L33.9716 32.5947H34.0334L34.2963 36.5531L32.0233 36.5222V56.9173C36.8321 56.8091 41.6255 55.4329 45.8004 52.6806C49.5733 50.2066 52.6349 46.743 54.5059 42.7845C55.0007 41.764 55.4182 40.6816 55.7584 39.6147C55.7893 39.5065 55.8357 39.3828 55.8666 39.2745C55.9748 38.9189 56.315 38.6715 56.7016 38.6869H57.9386C58.4952 38.6869 58.8973 39.1972 58.7581 39.7075C57.3201 45.0421 53.841 50.3148 49.3414 53.7475C44.2078 57.6595 38.0846 59.4532 32.0233 59.3914V64.0765C49.6816 64.0765 63.9999 49.7427 63.9999 32.0844C63.9999 14.4261 49.6816 0.0458984 32.0078 0.0458984V5.41142C40.9607 5.51966 49.7743 9.71002 54.9543 17.4413Z"
        fill="#106DFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_976_12559">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </StyledIcons>
);

export default EESIcon;
